module.exports = __webpack_public_path__ + "static/media/flags@2x.27670c53.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-intl-tel-input/dist/flags@2x.png
// module id = 596
// module chunks = 0 1 2 3 4 31